import { render, staticRenderFns } from "./ptSettings.vue?vue&type=template&id=b2adb042&lang=pug&"
import script from "./ptSettings.vue?vue&type=script&lang=js&"
export * from "./ptSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports